import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { MessagingTemplateConfiguration } from "@idw-types/data/messaging-template";

type GetMessagingTemplatesRequestResponse = {
    messagingTemplates: Array<MessagingTemplateConfiguration>;
};

export const getMessagingTemplatesRequest = async (): Promise<{ data: GetMessagingTemplatesRequestResponse, error: any }> => {
    const route = apiRoutes.axnadminCore.messagingTemplate;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};